import React, { useState } from "react";
import { Table } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  // imagesend,
  // pdficon,
  // pdficon3,
  // plusicon,
  refreshicon,
  // pdficon5,
} from "../imagepath";
// import { onShowSizeChange, itemRender } from "../Pagination";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
// import {
//   generateCsv,
//   handleShowJson,
// } from "../../utils/constant/constant";
// import dayjs from "dayjs";
// import jsPDF from "jspdf";
import { getAppointmentMatrix } from "../../connections/getAppointmentMatrix";

const AppointmentMatrix = () => {

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const {
    user: { user },
  } = useSelector((store) => store);
  // const navigate = useNavigate();

  const {
    data: appointmentMatrixList,
    isLoading: pharmacyLoader,
    refetch: refetchQuery,
  } = useQuery({
    queryKey: ["getAppointmentMatrix", page, pageSize],
    queryFn: () => getAppointmentMatrix(user?.token, null, page, pageSize),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Patient name",
      key: "patient_name",
      render: (_, record) => record.appointment?.patient_name || "-",
    },
    {
      title: "Hospital entry time",
      dataIndex: "hospital_entry_time",
      key: "hospital_entry_time",
    },
    {
      title: "Doctor cabin entry time",
      dataIndex: "doctor_cabin_entry_time",
      key: "doctor_cabin_entry_time",
    },
    {
      title: "Visit complete time",
      dataIndex: "visit_complete_time",
      key: "visit_complete_time",
    },
    {
      title: "Hospital leave time",
      dataIndex: "hospital_leave_time",
      key: "hospital_leave_time",
    },
    {
      title: "Waiting time",
      dataIndex: "waiting_time",
      key: "waiting_time",
    },
    {
      title: "All medicine purchased",
      dataIndex: "all_medicine_purchased",
      key: "all_medicine_purchased",
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   render: (_, record) => (
    //     <Dropdown
    //       overlay={
    //         <Menu>
    //           <Menu.Item
    //             key="edit"
    //             onClick={() =>
    //               navigate("/admin/update_quires", { state: record })
    //             }
    //           >
    //             <i className="far fa-edit me-2" /> Edit
    //           </Menu.Item>
    //         </Menu>
    //       }
    //       trigger={["click"]}
    //       placement="bottomRight"
    //     >
    //       <Link to="#" className="action-icon">
    //         <i className="fas fa-ellipsis-v" />
    //       </Link>
    //     </Dropdown>
    //   ),
    // },
  ];


  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
    // refetchQuery();
  };

  // const downloadPdf = (dataArray) => {
  //   // Return if no data
  //   if (!dataArray || dataArray.length === 0) return;

  //   // Initialize PDF document
  //   const doc = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   const headers = [
  //     { header: "Id", width: 20 },
  //     { header: "Name", width: 35 },
  //     { header: "DSt In No", width: 50 },
  //     { header: "DL No.", width: 40 },
  //     // { header: "Updated At", width: 40 },
  //   ];

  //   // Map data with formatting
  //   const data = dataArray?.map((item) => [
  //     item.id,
  //     item.name || "Empty",
  //     item.gstin_no || "Empty",
  //     item.dl_no || "Empty",
  //     //   item.updated_at,
  //   ]);

  //   // Add title
  //   doc.setFontSize(16);
  //   doc.setFont(undefined, "bold");
  //   doc.text("Query List", doc.internal.pageSize.getWidth() / 2, 15, {
  //     align: "center",
  //   });

  //   // Add timestamp
  //   doc.setFontSize(10);
  //   doc.setFont(undefined, "normal");
  //   doc.text(`Generated on: ${dayjs().format("YYYY-MM-DD HH:mm:ss")}`, 14, 22);

  //   // Configure table
  //   doc.autoTable({
  //     startY: 30,
  //     head: [headers.map((h) => h.header)],
  //     body: data,
  //     theme: "grid",
  //     headStyles: {
  //       fillColor: [240, 240, 240],
  //       textColor: [0, 0, 0],
  //       fontStyle: "bold",
  //       halign: "center",
  //       lineWidth: 0.5,
  //       lineColor: [200, 200, 200],
  //       fontSize: 10,
  //     },
  //     bodyStyles: {
  //       fontSize: 9,
  //       lineColor: [200, 200, 200],
  //       lineWidth: 0.5,
  //     },
  //     columnStyles: {
  //       0: { halign: "center" }, // ID
  //       1: { halign: "center" }, // Purchase Date
  //       2: { halign: "center" }, // Grand Total
  //       3: { halign: "center" }, // Paid
  //     },
  //     alternateRowStyles: {
  //       fillColor: [248, 248, 248],
  //     },
  //     margin: { top: 30, right: 14, bottom: 20, left: 14 },
  //     didDrawPage: (data) => {
  //       // Add page number at the bottom
  //       doc.setFontSize(10);
  //       doc.text(
  //         `Page ${data.pageNumber} of ${data.pageCount}`,
  //         doc.internal.pageSize.getWidth() / 2,
  //         doc.internal.pageSize.getHeight() - 10,
  //         { align: "center" }
  //       );
  //     },
  //   });

  //   // Save with formatted filename including timestamp
  //   const filename = `Pharmacy-List${dayjs().format("YYYYMMDD_HHmmss")}.pdf`;
  //   doc.save(filename);
  // };

  return (
    <>
      <Header />
      <Sidebar activeClassName="appointment_matrix" />
      <>
        <div className="page-wrapper">
          <div className="content">

            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Appointment matrix</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Appointment  Matrix</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* Table Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Appointment Matrix</h3>
                            <div className="doctor-search-blk">
                              <div className="add-group">
                                <Link
                                  onClick={refetchQuery}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img

                                    src={refreshicon}
                                    alt="#"
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* 
                        <div className="col-auto text-end float-end ms-auto download-grp">

                          <img
                            className=" me-2"
                            onClick={() =>
                              downloadPdf(
                                appointmentMatrixList?.payload?.queries
                              )
                            }
                            src={pdficon}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />

                          <img
                            onClick={() =>
                              generateCsv(
                                appointmentMatrixList?.payload?.queries
                              )
                            }
                            className=" me-2"
                            src={pdficon3}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />

                          <img
                            onClick={() =>
                              handleShowJson(
                                appointmentMatrixList?.payload?.appointment_matrices
                              )
                            }
                            width={"25px"}
                            height={"26px"}
                            src={pdficon5}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                        </div> */}

                      </div>
                    </div>

                    <div className="table-responsive doctor-list">
                      <Table
                        loading={pharmacyLoader}
                        pagination={{
                          current: page,
                          pageSize: pageSize,
                          total: appointmentMatrixList?.meta?.total_count,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: handlePageChange,
                        }}
                        scroll={{ x: "max-content" }}
                        columns={columns}
                        dataSource={appointmentMatrixList?.payload?.appointment_matrices}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                {/* <img src={imagesend} alt="#" width={50} height={46} /> */}
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  {/* <button
                    // onClick={handleDeleteRow}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button> */}
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  {/* <img src={imagesend} alt="#" width={50} height={46} /> */}
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      ;
    </>
  );
};

export default AppointmentMatrix;
